<template>
    <div class="cursus-badge" :class="classes">
        {{ course.registration_label }}
    </div>
</template>

<script>
    export default {
        props: {
            course: Object,
            action: Boolean,
        },
        computed: {
            classes() {
                return {
                    // 'border-0 text-reset bg-transparent': this.course.without_show_page,
                }
            },
        },
    }
</script>
